module.exports = __webpack_public_path__ + "static/media/59.ef74f1ab.svg";